<template>
  <div id="pers-tab5" name="hres31x-tab5" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">

    <!--Start Topic #1-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-btc icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31C5P1']['10'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['30'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['numtaxid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['60'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['numsaid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['40'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['tax_deduct'] }}</div>
      </div>

       <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['70'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail.detail['frsmemb']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['50'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['tax_payment'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['80'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['codcln'] }}</div>
      </div>
    </div>
    <!--End Topic #1-->

    <!--Start Topic #2-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic2">
      <i class="fa fa-university icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31C5P1']['90'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic2">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['100'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['codbank1'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['110'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['numbank'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['120'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['amtbank'] }}</div>
      </div>

       <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['130'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['codbank2'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P1']['140'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['numbank2'] }}</div>
      </div>
    </div>
    <!--End Topic #2-->

    <!--Start Topic #3-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic3">
      <i class="fa fa-btc icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31C5P2']['10'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic3">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['30'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail.detail['dtebf']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['40'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['amtincbf'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['60'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['amttaxbf'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['50'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['amtpf'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['70'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['amtsaid'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
      </div>

      <!--Start Topic #3 LV #2-->
      <div class="lv2-sub-topic-box">
        <!--<i class="fa fa-btc lv2-icon-sub-topic" aria-hidden="true"></i>-->
        <div class="lv2-sub-topic color-skin">{{ labels['HRES31C5P2']['80'] }}</div>
      </div>

      <div class="data-pers-box">
        <div class="row data-box">
          <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['90'] }}</div>
          <div class="col-xs-6 data-text">{{ setDateOutput(detail.detail['dtebfsp']) }}</div>
        </div>

        <div class="row data-box">
          <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['100'] }}</div>
          <div class="col-xs-6 data-text">{{ detail.detail['amtincsp'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
        </div>

        <div class="row data-box">
          <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['120'] }}</div>
          <div class="col-xs-6 data-text">{{ detail.detail['amttaxsp'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
        </div>

        <div class="row data-box">
          <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['110'] }}</div>
          <div class="col-xs-6 data-text">{{ detail.detail['amtpfsp'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
        </div>

        <div class="row data-box">
          <div class="col-xs-6 data-label">{{ labels['HRES31C5P2']['130'] }}</div>
          <div class="col-xs-6 data-text">{{ detail.detail['amtsasp'] }} &nbsp; {{ labels['HRES31XC1']['270'] }}</div>
        </div>
      </div>
      <!--END Topic #3 LV #2-->
      <!--Start Editor Box-->
      <div class="row data-box editor-row">
        <div class="col-xs-6 data-label color-skin">{{ labels['HRES31C5P2']['140'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail.detail['dteupd']) }}</div>
      </div>

      <div class="row data-box editor-row">
        <div class="col-xs-6 data-label color-skin">{{ labels['HRES31C5P2']['150'] }}</div>
        <div class="col-xs-6 data-text">{{ detail.detail['coduser'] }}</div>
      </div>
      <!--End Editor Box-->
    </div>
    <!--End Topic #3-->

    <!--Table Topic 4-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic4">
      <i class="fa fa-btc icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31C5P3']['10'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic4">
      <div class="tax-table-box clearfix">
        <div class="col-xs-12 tax-table-heading-left bg-color-skin">{{ labels['HRES31C5P3']['20'] }} - {{ labels['HRES31C5P3']['30'] }}</div>
        <div class="col-xs-12 tax-table-heading-right bg-color-skin">{{ labels['HRES31C5P3']['40'] }}</div>
        <div class="col-xs-12 tax-table-heading-right bg-color-skin">{{ labels['HRES31C5P3']['50'] }}</div>
      </div>

      <template v-for="(value, index) in detail.tableTaxExemption.rows">
        <div class="tax-table-box clearfix" :class="{'even' : index%2 == 0}">
          <div class="col-xs-12 tax-table-body-left color-skin">{{ value.coddeduct }} - {{ value.desc_coddeduct }}</div>
          <div class="col-xs-12 tax-table-body-right">
            {{ labels['HRES31C5P3']['40'] }} &nbsp; {{ value.v_amtdeduct }} &nbsp; {{ labels['HRES31XC1']['270'] }}
          </div>
          <div class="col-xs-12 tax-table-body-right">
            {{ labels['HRES31C5P3']['50'] }} &nbsp; {{ value.v_amtspded }} &nbsp; {{ labels['HRES31XC1']['270'] }}
          </div>
        </div>
      </template>
    </div>
    <!--End Table Topic 4-->

    <!--Table Topic 5-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic5">
      <i class="fa fa-btc icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31C5P4']['10'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic5">
      <div class="tax-table-box clearfix">
        <div class="col-xs-12 tax-table-heading-left bg-color-skin">{{ labels['HRES31C5P4']['20'] }} - {{ labels['HRES31C5P4']['30'] }}</div>
        <div class="col-xs-12 tax-table-heading-right bg-color-skin">{{ labels['HRES31C5P4']['40'] }}</div>
        <div class="col-xs-12 tax-table-heading-right bg-color-skin">{{ labels['HRES31C5P4']['50'] }}</div>
      </div>

      <template v-for="(value, index) in detail.tableTaxDeduction.rows">
        <div class="tax-table-box clearfix" :class="{'even' : index%2 == 0}">
          <div class="col-xs-12 tax-table-body-left color-skin">{{ value.coddeduct }} - {{ value.desc_coddeduct }}</div>
          <div class="col-xs-12 tax-table-body-right">
            {{ labels['HRES31C5P4']['40'] }} &nbsp; {{ value.v_amtdeduct }} &nbsp; {{ labels['HRES31XC1']['270'] }}
          </div>
          <div class="col-xs-12 tax-table-body-right">
            {{ labels['HRES31C5P4']['50'] }} &nbsp; {{ value.v_amtspded }} &nbsp; {{ labels['HRES31XC1']['270'] }}
          </div>
        </div>

        <template v-if="index == detail.tableTaxDeduction.rows.length - 1">
          <!--Start Editor Box-->
          <div class="row data-box editor-row">
            <div class="col-xs-8 data-label color-skin">{{ labels['HRES31C5P4']['60'] }}</div>
            <div class="col-xs-4 data-text">
              {{ value.qtychedu }} &nbsp; {{ labels['HRES31C5P4']['70'] }}
            </div>
          </div>

          <div class="row data-box editor-row">
            <div class="col-xs-8 data-label color-skin">{{ labels['HRES31C5P4']['80'] }}</div>
            <div class="col-xs-4 data-text">
              {{ value.qtychned }} &nbsp; {{ labels['HRES31C5P4']['90'] }}
            </div>
          </div>
          <!--End Editor Box-->
        </template>
      </template>
    </div>
    <!--End Table Topic 5-->

    <!--Table Topic 5-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic6">
      <i class="fa fa-btc icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31C5P5']['10'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic6">
      <div class="tax-table-box clearfix">
        <div class="col-xs-12 tax-table-heading-left bg-color-skin">{{ labels['HRES31C5P5']['20'] }} - {{ labels['HRES31C5P5']['30'] }}</div>
        <div class="col-xs-12 tax-table-heading-right bg-color-skin">{{ labels['HRES31C5P5']['40'] }}</div>
        <div class="col-xs-12 tax-table-heading-right bg-color-skin">{{ labels['HRES31C5P5']['50'] }}</div>
      </div>

      <template v-for="(value, index) in detail.tableOtherDeduction.rows">
        <div class="tax-table-box clearfix" :class="{'even' : index%2 == 0}">
          <div class="col-xs-12 tax-table-body-left color-skin">{{ value.coddeduct }} - {{ value.desc_coddeduct }}</div>
          <div class="col-xs-12 tax-table-body-right">
            {{ labels['HRES31C5P5']['40'] }} &nbsp; {{ value.v_amtdeduct }} &nbsp; {{ labels['HRES31XC1']['270'] }}
          </div>
          <div class="col-xs-12 tax-table-body-right">
            {{ labels['HRES31C5P5']['50'] }} &nbsp; {{ value.v_amtspded }} &nbsp; {{ labels['HRES31XC1']['270'] }}
          </div>
        </div>
      </template>
    </div>
    <!--End Table Topic 5-->

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres31x-tab5',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      subTopic3: true,
      subTopic4: true,
      subTopic5: true,
      subTopic6: true
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    },
    toggleSubTopic4 () {
      this.subTopic4 = !this.subTopic4
    },
    toggleSubTopic5 () {
      this.subTopic5 = !this.subTopic5
    },
    toggleSubTopic6 () {
      this.subTopic6 = !this.subTopic6
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>



// WEBPACK FOOTER //
// tab5.vue?32e169f5